import React from "react";
import FormCreateCategory from "../../../../../molecules/Form/FormCreateCategory";
import { DUMMY_DATA } from "../screen";
import { useNavigate } from 'react-router-dom';


const Screen = () => {
  const navigate = useNavigate();
  const submitHandler = (name) => {
    const id = DUMMY_DATA.length + 1;
    const newData = {
      id: id,
      name: name
    }
    DUMMY_DATA.push(newData);
    navigate("/business/dashboard/category-business")
  }
  return (
    <>
      <div className="h-full w-full flex justify-center items-center">
        <div className="w-[70%] h-auto m-6 rounded-lg bg-gray-100 flex flex-col items-center">
          <h1 className='center mt-6 font-bold text-xl'>Category Business</h1>
          <div className="form-group">
            <FormCreateCategory submitHandler={submitHandler}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Screen;